import React, { FunctionComponent } from "react";
import { Grid } from "@mui/material";
import styles from "./styles.module.scss";
import { ShortcutItem } from "../ShortcutItem";
import { strings } from "../../localization/LocalizedStrings";
import { useNavigate } from "react-router";
import { RoutesBuilder } from "../../models/RoutesBuilder";
import classNames from "classnames";
import { useSessionManager, useUser } from "../../hooks/session";
import { productIconMap } from "../../models/ProductUtilities";
import { ProductType } from "../../hooks/products/interfaces";
import { IconType } from "../../icons";

export const ShortcutsGrid: FunctionComponent<IShortcutsGridProps> = ({
  className,
  isPublic,
  minimalist,
  showAttributesShortcut,
  onNewAlbum,
  onImportFromDiscogs,
  onImportFromExcel,
  onFilterAlbums,
  onRandomAlbums,
  onChangeCollection,
  onEditProfile,
  onScanBarcode
}) => {
  const [currentUser] = useUser.useState();
  const { closeSession } = useSessionManager();
  const navigate = useNavigate();
  return (
    <Grid className={classNames(styles.grid, className)} container spacing={2}>
      {(!minimalist || isPublic) && currentUser?.role == "guest" && (
        <ShortcutItem
          iconType={IconType.PersonAdd}
          title={strings.shortcuts_create_user}
          onClick={() => {
            closeSession();
            navigate(RoutesBuilder.signIn());
          }}
        />
      )}
      {!isPublic && onNewAlbum && (
        <ShortcutItem
          iconType={IconType.AddAd}
          title={strings.shortcuts_add_albums}
          onClick={onNewAlbum}
        />
      )}
      {!isPublic && onScanBarcode && (
        <ShortcutItem
          iconType={IconType.QRCode2Add}
          title={strings.shortcuts_scan_barcode}
          onClick={onScanBarcode}
        />
      )}
      {!isPublic && onImportFromDiscogs && (
        <ShortcutItem
          iconType={IconType.CloudDownload}
          title={strings.shortcuts_discogs_import}
          onClick={onImportFromDiscogs}
        />
      )}
      {!isPublic && onImportFromExcel && (
        <ShortcutItem
          iconType={IconType.FormsAddOn}
          title={strings.shortcuts_excel_import}
          onClick={onImportFromExcel}
        />
      )}
      {onFilterAlbums && (
        <ShortcutItem
          iconType={IconType.FilterAlt}
          title={isPublic ? strings.shortcuts_filter_public : strings.shortcuts_filter}
          onClick={onFilterAlbums}
        />
      )}
      {!minimalist && onRandomAlbums && (
        <ShortcutItem
          iconType={IconType.Die}
          title={strings.shortcuts_random_albums}
          onClick={onRandomAlbums}
        />
      )}
      {!isPublic && !minimalist && (
        <ShortcutItem
          iconType={productIconMap[ProductType.SHELVINGS]}
          title={strings.shortcuts_layout}
          onClick={() => navigate(RoutesBuilder.layout())}
        />
      )}
      {!isPublic && !minimalist && currentUser?.role != "guest" && (
        <ShortcutItem
          iconType={IconType.AreaChart}
          title={strings.shortcuts_stats}
          onClick={() => navigate(RoutesBuilder.stats())}
        />
      )}
      {!isPublic &&
        !minimalist &&
        (showAttributesShortcut ? (
          <ShortcutItem
            iconType={IconType.Assignment}
            title={strings.shortcuts_attributes}
            onClick={() => navigate(RoutesBuilder.attributes.manage())}
          />
        ) : (
          <ShortcutItem
            iconType={productIconMap[ProductType.ALBUMS]}
            title={strings.shortcuts_albums}
            onClick={() => navigate(RoutesBuilder.albums.list())}
          />
        ))}
      {!isPublic && onChangeCollection && (
        <ShortcutItem
          iconType={productIconMap[ProductType.COLLECTIONS]}
          title={strings.shortcuts_change_collection}
          onClick={onChangeCollection}
        />
      )}
      {(!minimalist || isPublic) && (
        <ShortcutItem
          iconType={IconType.Public}
          title={strings.shortcuts_marketplace}
          onClick={() => navigate(RoutesBuilder.marketplace())}
        />
      )}
      {currentUser?.role != "guest" && onEditProfile && (
        <ShortcutItem
          iconType={IconType.AccountCircle}
          title={strings.shortcuts_edit_profile}
          onClick={onEditProfile}
        />
      )}
      <ShortcutItem
        iconType={IconType.Book2}
        title={strings.shortcuts_documentation}
        onClick={() => navigate(RoutesBuilder.documentation.home())}
      />
    </Grid>
  );
};

export interface IShortcutsGridProps {
  className?: string;
  isPublic: boolean;
  minimalist?: boolean;
  showAttributesShortcut: boolean;
  onNewAlbum?: () => void;
  onImportFromDiscogs?: () => void;
  onImportFromExcel?: () => void;
  onFilterAlbums?: () => void;
  onRandomAlbums?: () => void;
  onChangeCollection?: () => void;
  onEditProfile?: () => void;
  onScanBarcode?: () => void;
}
